import Table from "components/Table2";
import { useFormikContext } from "formik";
import BasicButton from "components/BasicInputs/BasicButton";
import PlusIcon from "assets/icons/PlusIcon";
import shortid from "shortid";
import { BoxesIcon } from "assets/icons/BoxesIcon";
import Product from "./comps/product";
import Quantity from "./comps/quantity";
import Warehouse from "./comps/warehouse";
import UnitPrice from "./comps/unitPrice";
import TotalPrice from "./comps/totalPrice";
import useResponsive from "helpers/useResponsive";
import useCurrency from "helpers/useCurrency";
import { useEffect } from "react";
import { formatPrice } from "helpers/dataFormat";
import { calculateTableTotalPrice } from "../../utils";

export default function Materials() {
  const data = useFormikContext<MaterialOrderData>();
  const { isMobile } = useResponsive();
  const { defCur } = useCurrency();

  useEffect(() => {
    const totalPrice = calculateTableTotalPrice(data.values.materialsRows);

    data.setFieldValue("tableTotalPrice", totalPrice);
  }, [data.values.materialsRows]);

  return (
    <div>
      <div className="flex items-end gap-4 mb-10">
        <BoxesIcon />
        <span className="text-lg">مواد مصرفی</span>
        <div className="bg-[#E8F0FF] px-2 py-1 rounded-md text-sm text-zinc-600">
          مواد مصرفی برای تولید یک کالا در نظر گرفته میشود
        </div>
      </div>

      <Table
        headers={[
          { label: "کالا" },
          { label: "انبار کالای مصرفی" },
          { label: "مقدار" },
          { label: "قیمت واحد" },
          { label: "مبلغ کل" },
        ]}
        cols={[
          { Comp: Product, key: "productId" },
          { Comp: Warehouse, key: "warehouse" },
          { Comp: Quantity, key: "quantity" },
          { Comp: UnitPrice, key: "unitPrice" },
          { Comp: TotalPrice, key: "totalPrice" },
        ]}
        bgColor="#fff"
        headerColor="#fff"
        rows={data.values.materialsRows}
        withBorder={true}
        tableBorder={false}
        noScroll={!isMobile}
        onDelete={(row: MaterialsRow) => {
          const newRows = data.values.materialsRows?.filter((x: any) => x.ind !== row.ind);
          data.setFieldValue("materialsRows", newRows);
        }}
      />

      <div className={`flex items-center justify-between pl-[60px] mt-6 ${isMobile && "px-3"}`}>
        <BasicButton
          className="text-[#1062D0] bg-[#D6E4FF] py-2 pr-3 pl-6"
          variant="text"
          onClick={() => {
            const newRows = [...(data.values.materialsRows || [])];
            newRows.push({ ind: shortid.generate(), quantity: 0, unitPrice: 0, totalPrice: 0 });
            data.setFieldValue("materialsRows", newRows);
          }}
        >
          <PlusIcon scale={0.7} />
          <span>افزودن ردیف</span>
        </BasicButton>

        <div className="flex gap-4">
          <span>مجموع</span>
          <span>{formatPrice(data.values.tableTotalPrice)}</span>
          <span className="text-dark-3">{defCur.en_title}</span>
        </div>
      </div>
    </div>
  );
}
